import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import noop from '@gik/core/utils/noop';

export interface IYesNoButtonInputProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
}

const blockName = 'yes-no-button-input';

export default function YesNoButtonInput({ value, onChange = noop }: IYesNoButtonInputProps) {
  const bem = bemBlock(blockName);

  const [_value, _setValue] = React.useState<boolean>(value);

  function getValue() {
    if (value !== undefined) {
      return value;
    } else {
      return _value;
    }
  }

  function handleChange(newValue: boolean) {
    if (value === undefined) {
      _setValue(newValue);
    }
    onChange(newValue);
  }

  return (
    <div className={bem()}>
      <div
        className={bem('button', [
          {
            'yes-button': true,
          },
          {
            selected: getValue() === true,
          },
        ])}
        onClick={() => handleChange(true)}
      >
        Yes
      </div>
      <div
        className={bem('button', [
          {
            'no-button': true,
          },
          {
            selected: getValue() === false,
          },
        ])}
        onClick={() => handleChange(false)}
      >
        No
      </div>
    </div>
  );
}
